module.exports = __webpack_public_path__ + "img/card-global.9b1f52c3.svg";